import styled from 'styled-components';

export const SizeBoxesOutter = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 720px) {
    overflow-x: scroll;
    flex-wrap: inherit;
    justify-content: ${(props) =>
      props.showNewDiaperVariantUx && !props.botPadding ? 'center' : ''};

    &::-webkit-scrollbar {
      display: none;
    }
  }

  & li {
    white-space: nowrap;
    text-align: center;
    font-size: 12px;
    min-width: 80px;
    flex-shrink: 0;
    margin: 0 15px 4px 0;

    @media (max-width: 720px) {
      flex-basis: 25%;
      min-width: auto;
      margin: ${(props) =>
        props.showNewDiaperVariantUx ? '0 4px 4px 0' : '0 15px 4px 0'};
    }
  }
`;

export const SizeBoxesNewContainer = styled.div`
  .lowestPrice {
    background: #ffccd0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 3px 0;
    font-size: 10px;
    color: #5c5c5c;
    font-weight: 600;
    text-align: center;
    width: 80%;
  }
  @media (max-width: 720px) {
    flex-basis: ${(props) => (props.botPadding ? '33.3%' : '')};
  }
`;

export const SizeBoxesLi = styled.li`
  font-weight: ${(props) => (props.active ? '600' : '500')};
  color: ${(props) => (props.active ? '#ef4e5e' : 'hsl(0deg,0%,0%,48%)')};
  text-transform: uppercase;
  cursor: pointer;

  .size_title {
    border: ${(props) =>
      props.active ? '1px solid #ef4e5e' : '1px solid hsl(0deg,0%,0%,20%)'};

    height: 32px;
    line-height: 32px;
    padding: 0 8px;
  }
  .size_price {
    padding-top: 4px;
  }
`;

export const SizeBoxesLiNew = styled.li`
  border: ${(props) =>
    props.active ? '1px solid #ef4e5e' : '1px solid #e5e5e5'};
  border-radius: 4px;
  background-color: ${(props) => (props.active ? '#fefafa' : '#fff')};
  flex-basis: unset !important;
  padding: ${(props) => (props.botPadding ? '6px 0' : '6px 0px 0')};
  .sizeTag {
    font-size: 14px;
    font-weight: 500;
    opacity: 0.87;
    padding: 0 10px;
  }
  .weightTag {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.54;
    margin-top: 4px;
  }
  .packTag {
    font-size: 14px;
    font-weight: 600;
    opacity: 0.87;
    background: #fefafa;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 6px 6px;
    text-align: left;
  }
  .pricePerUnit {
    font-size: 12px;
    font-weight: 600;
    color: #63b0a9;
    text-align: left;
  }
  .priceFlex {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    margin: 6px 0;
  }

  .price {
    font-size: 14px;
    opacity: 0.87;
    font-weight: 600;
  }

  .discount {
    color: #63b0a9;
    font-size: 12px;
    text-align: left;
    font-weight: 500;
  }
  .strikeprice {
    font-size: 12px;
    color: #6e6e6e;
    text-decoration: line-through;
    text-align: left;
    margin: 4px 0;
  }
  .bestVal {
    width: 117%;
    margin-left: -9%;
    background: #e2e6ff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: 8px;
    padding: 3px 0;
    font-size: 12px;
    color: #805020;
    font-weight: 400;
  }
  .mostBought {
    width: 117%;
    margin-left: -9%;
    background: #ffede2;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: 8px;
    padding: 3px 0;
    font-size: 12px;
    color: #805020;
    font-weight: 400;
  }
`;

export const SizeBoxesLiNewV2 = styled.li`
  border: ${(props) =>
    props.active ? '2px solid #ef4e5e !important' : '1px solid #e5e5e5'};
  border-radius: 10px;
  background-color: ${(props) => (props.active ? '#fef9f9' : '#fff')};
  flex-basis: ${(props) => (!props.botPadding ? '18%' : 'unset !important')};
  padding: ${(props) => (props.botPadding ? '6px 0' : '6px 8px 0')};
  @media (max-width: 720px) {
    padding: ${(props) => (props.botPadding ? '6px 0' : '2px 0px 0')};
    ${(props) =>
      props.packsCount > 3 &&
      `
          min-width: 130px; 
          overflow-x: auto; 
      `}
  }
  .sizeTag {
    font-size: 15px;
    font-weight:  ${(props) =>
    props.active ? '600' : '0'};
    opacity: 0.87;
    padding: 0 10px;
  }
  .weightTag {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.54;
    margin-top: 4px;
    padding: 0 6px;
  }
  .packTag {
    font-size: ${(props) => (props.showCDNewVariantUx ? '14px' : '17px')};
    font-weight: 600;
    padding: 10px 2px;
    text-align: left;
    @media (max-width: 720px) {
      font-size: 14px;
      padding: 6px;
    }
  }
  img {
    width: 125px;
    height: 110px;
    @media (max-width: 720px) {
      width: 100%;
      height: auto;
      padding: 0px 6px;
    }
  }
  .pricePerUnit {
    font-size: 16px;
    color: #212121;
    text-align: left;
    span {
      font-size: 12px;
    }
    @media (max-width: 720px) {
      font-size: 14px;
      span {
        font-size: 10px;
      }
      margin: 0px 4px 11px 4px;
    }
  }
  .priceFlex {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    margin: 6px 0;
    margin-top: 12px;
    @media (max-width: 720px) {
      margin: 0px 4px;
      margin-bottom: 0px;
    }
  }

  .price {
    font-size: 14px;
    font-weight: 600;
    margin: 5px 0px;
    color: #000000a8;
    text-align: left;
    margin-bottom: 14px;
    span {
      font-size: 12px;
      padding: 0 2px;
      font-weight: ${(props) => (props.showCDNewVariantUx ? '600' : '')};
    }
    @media (max-width: 720px) {
      margin: 5px 4px;
      margin-bottom: 16px;
      margin-top: 0px;
      span {
        font-size: 10px;
      }
    }
  }

  .discount {
    color: #63b0a9;
    font-size: 14px;
    text-align: left;
    font-weight: 600;
    @media (max-width: 720px) {
      font-size: 12px;
    }
  }
  .strikeprice {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.38);
    text-decoration: line-through;
    text-align: left;
    margin: 4px 0;
    @media (max-width: 720px) {
      font-size: 12px;
    }
  }
`;
